module.exports = new __parcel__URL__("uber-grocery.ddec2f17.png").toString();